import React from "react";

interface SpeakerOffIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Speaker icon with line through it - indicates TTS is disabled/muted
 */
export const SpeakerOffIcon: React.FC<SpeakerOffIconProps> = ({
  width = 16,
  height = 16,
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      {/* Speaker cone */}
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      {/* X through speaker */}
      <line x1="22" y1="9" x2="16" y2="15" />
      <line x1="16" y1="9" x2="22" y2="15" />
    </svg>
  );
};
